class FacetsFilterCollections extends HTMLElement {
    connectedCallback () {
        this.parentCount = parseInt(this.dataset.parentCount || '0', 10);

        // If only one parent, children are always visible
        if (this.parentCount <= 1) return;

        this.syncChildVisibility();

        this.addEventListener('change', (event) => {
            const target = event.target;
            if (!target || target.type !== 'checkbox') return;
            this.syncChildVisibility();
        });
    }

    syncChildVisibility () {
        const selectedParents = {};
        const childCheckedParents = {};

        this.querySelectorAll('[data-is-child]').forEach((childRow) => {
            const parentLabel = (childRow.dataset.childOf || '').trim();
            const childInput = childRow.querySelector('input[type="checkbox"]');

            if (parentLabel && childInput && childInput.checked) {
                childCheckedParents[parentLabel] = true;
            }
        });

        this.querySelectorAll('[data-is-parent]').forEach((parentRow) => {
            const input = parentRow.querySelector('input[type="checkbox"]');
            const label = (parentRow.dataset.parentLabel || '').trim();
            const parentLabel = parentRow.querySelector('label');

            if (!input || !label) return;

            if (childCheckedParents[label]) {
                input.checked = false;
                if (parentLabel) parentLabel.classList.add('selected');
                selectedParents[label] = true;
            } else {
                if (parentLabel) parentLabel.classList.remove('selected');
                if (input.checked) {
                    selectedParents[label] = true;
                }
            }
        });

        this.querySelectorAll('[data-is-child]').forEach((childRow) => {
            const parentLabel = (childRow.dataset.childOf || '').trim();
            const childInput = childRow.querySelector('input[type="checkbox"]');
            const childChecked = childInput ? childInput.checked : false;

            if (childChecked || selectedParents[parentLabel]) {
                childRow.classList.remove('hidden');
            } else {
                childRow.classList.add('hidden');
            }
        });
    }
}

customElements.define('facets-filter-collections', FacetsFilterCollections);
